import { atom } from 'jotai';

export const registerSuccessAtom = atom<boolean>(false);
export const selectedAddressAtom = atom<string | null>(null);

export const isClaimingAtom = atom<boolean>(false);
export const isDecompressingAtom = atom<boolean>(false);
export const isAirdroppingAtom = atom<boolean>(false);
export const successAtom = atom<boolean>(false);
export const errorAtom = atom<string | null>(null);
export const txIdAtom = atom<string | null>(null);

export const compressedBalanceAtom = atom<Record<string, number | null>>({});
export const decompressedBalanceAtom = atom<number | null>(null);
